<template>
    <div id="task">
        <template v-if="cantAccessPageResale === true">
            <div class="container-fluid xyz">
                <div :class="'page-header-top-container'+titleMargin">
                    <div class="page-name color-71aa3f">{{resalePageData.pageTitle}}</div>
                    <template v-for="(permission, index) in permissionsResale">
                        <button title="Add" v-if="permission.name == 'can_add_new_resale_reason'"  type="button" class="btn general-button btn-primary icon-btn" id="submit" name="submit"
                                v-on:click.prevent="editResaleReason">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>

                        <!--button title="Import" v-if="permission.name == 'can_import_tasks_data' && resalePageData.cus_id == 0" type="button" class="btn general-button btn-primary icon-btn" data-toggle="modal" data-target="#TaskdefaultModal">
                            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                        </button>
                        <button title="Export" v-if="permission.name == 'can_export_tasks_data'" type="button" id='exportTask' class="btn general-button btn-primary icon-btn"
                                v-on:click="exportTask($event)">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                        </button-->
                    </template>
                    <!--div class="btn-group pull-right">
                        <button type="button" class="btn_all_task btn general-button btn-primary" v-on:click="allClick()">All</button>
                        <button type="button" class="btn_my_task btn general-button btn-secondary" v-on:click="myClick()">My Self</button>
                    </div-->
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="resaleReasonTable"
                                        ref="listResaleReasonTable"
                                        mode="remote"
                                        title="Resale Reason"
                                        @on-page-change="onPageChangeResale"
                                        @on-selected-rows-change="selectionChangedResale"
                                        @on-column-filter="onColumnFilterResale"
                                        @on-per-page-change="onPerPageChangeResale"
                                        @on-sort-change="onSortChangeResale"
                                        :totalRows="totalRecordsResale"
                                        :columns="columnsResale"
                                        :rows="rowsResale"
                                        :pagination-options="{
                                            enabled: true,
                                            mode: 'pages',
                                            pageLabel: 'Page',
                                            position: 'bottom',
                                            perPage: serverParamsResale.perPage,
                                            setCurrentPage: serverParamsResale.setCurrentPage,
                                            perPageDropdown: serverParamsResale.perPageDropdown,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: false,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                            enabled: false,
                                        }"
                                        >
                            <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm" v-if="totalRecordsResale > 0">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParamsResale.perPage"
                                                      @change="changedValueResale"
                                                      @input="changedValueResaleCustomPerPageResale()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="serverParamsResale.perPageDropdown"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayrowsResale}} of {{totalRecordsResale}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParamsResale.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickResale(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParamsResale.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickResale(Number(serverParamsResale.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberListResale() < displayPageResale">
                                                    <template v-for="(n, index) in pageNumberListResale()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsResale.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickResale(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParamsResale.page) <= pageCompareResale">
                                                        <template v-for="(n, index) in displayPageResale">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsResale.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickResale(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParamsResale.page) >= (pageNumberListResale() - (pageCompareResale-1))">
                                                        <template v-for="(n, index) in pageNumberListResale()">
                                                            <template v-if="n > (pageNumberListResale() - displayPageResale)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsResale.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickResale(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberListResale()" v-if="(n >= (Number(serverParamsResale.page) - (pageCompareResale -1))) && (n <= (Number(serverParamsResale.page) + (pageCompareResale -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsResale.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickResale(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParamsResale.page) == pageNumberListResale()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickResale(Number(serverParamsResale.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParamsResale.page) == pageNumberListResale()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListResale()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickResale(pageNumberListResale())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListResale()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInResale" v-model="jumpToPageResale" type="text" class="form-control form-control-sm" name="jumpToPageResale" id="jumpToPageResale" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>


                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rowsResale">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <template v-if="permission.name == 'can_add_new_resale_reason'" v-for="(permission, index) in permissionsResale">
                                            <router-link title='Edit Resale Reason' class="btn edit-btn-vvg" v-bind:to="{name: 'EditResaleReason',params:{id:props.row.ItmId,last:lastId}}"><i class="fa fa-pencil-square-o"></i></router-link>
                                        </template>
                                    </div>
                                    <!--div v-else-if="props.column.field == 'sv_tax_id'">
                                        {{ props.row.sv_tax_des }} - {{ props.row.sv_tax_id }}
                                    </div>
                                    <div v-else-if="props.column.field == 'pt_tax_id'">
                                        {{ props.row.pt_tax_des }} - {{ props.row.pt_tax_id }}
                                    </div-->
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>

                            <!--<div slot="selected-row-actions" slot-scope="computed">-->
                            <!--{{computed.selectedRows}}-->
                            <!--<button v-on:click="onDeleteClick">Delete</button>-->
                            <!--</div>-->
                            <!--template  v-for="(permission, index) in permissionsResale">
                                <div slot="selected-row-actions">
                                    <button title='Delete Resale Reason' v-if="permission.name == 'can_add_new_resale'" id="deleteTaskBtn" v-on:click.prevent="onDeleteClick" class="btn general-button btn-success">Delete</button>
                                </div>
                            </template-->
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access resale.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import SessioMixin from '../../mixins/sessionmixin';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import EventBus from '../event-bus';
    import {addTask} from '../../config';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    export default {
        name: "taskcomponent",
        mixins: [SessioMixin],
        props: {
            resalePageData: '',
        },
        data: () => ({
                lastId: 0,
                titleMargin: '',
                displayPageResale: 7,
                pageCompareResale: 0,
                paginationDisplayrowsResale: '',
                jumpToPageResale: 0,

                loginIDTask: 0,
                permissionsResale: [],
                cantAccessPageResale: true,
                messageTask: 'all',
                // filteredFlag: false,
                exportFilteredFlagTask: false,
                filesTask: [],
                isLoggedInTask: false,
                firstLoadTask: 0,
                isHideColumns: false,
                columnsResale: [
                    {
                        label: 'Resale Reason',
                        field: 'SettingValue',
                        filterable: true,
                        sortable: false,
                        hidden: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Resale Reason", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '106px',
//                    :sort-options = {
//                        enable : false
//                }

                    },
                ],
                rowsResale: [],
                totalRecordsResale: 0,
                serverParamsResale: {
                    columnFilters: {},
                    sort: {
                        field: 'created_at',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    perPageDropdown: [],
                },
            }),
        beforeMount: function () {
            var self = this;
            if (self.resalePageData.is_cust_detail == true) {
                self.columnsResale['0'].hidden = true;
                self.columnsResale['1'].hidden = true;
            }
            var check = window.localStorage.getItem('api_token');
            if (check != null) {
                self.isLoggedInTask = true;
                self.getpermissionsResale();

            }
        },
        mounted: function () {

            var app = this;
            app.isHideColumns = app.resalePageData.is_cust_detail;
            if (app.resalePageData.cus_id > 0) {
                app.loadFilters('menuresalecustomer', app.columnsResale, app.serverParamsResale, "resaleReasonTable");
            } else {
                app.loadFilters('menuresalereason', app.columnsResale, app.serverParamsResale, "resaleReasonTable");
            }
            var initial = process.env.ROOT_API;
            var initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Tasks.xlsx');
            app.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginIDTask = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            this.jumpToPageResale = this.serverParamsResale.page;
            this.pageCompareResale = Math.ceil(this.displayPageResale / 2);
            $("#jumpToPageResale").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPageResale(app.jumpToPageResale)
                }
            });
            if (app.resalePageData.is_part == 1) {
                app.titleMargin = " pt-0";
            }
            this.serverParamsResale.perPage = this.resalePageData.perPage;
            for (var i = this.resalePageData.perPage; i < 100; ) {
                this.serverParamsResale.perPageDropdown.push(i);
                if (this.resalePageData.perPage < 5) {
                    i = i * 5;
                } else {
                    i = i * 2;
                }
            }
            this.serverParamsResale.perPageDropdown.push(100);
            this.serverParamsResale.perPageDropdown.push(200);
            this.serverParamsResale.perPageDropdown.push(500);
            /*setTimeout(function () {
             $('.filter-th .vgt-select').addClass("custom-select");
             }, 100);*/
             console.log("mount");
            this.loadResaleComponent();
        },
        methods: {
            /* Custome pagination Methods started */
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            jumpToPageInResale: function (e) {
                let self = this;
                self.jumpToInputPageResale(self.jumpToPageResale);
            },
            changedValueResale: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPageResale: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListResale()) {
                    pageNumber = self.pageNumberListResale();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageResale).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickResale(pageNumber);
            },
            onPerticularPageClickResale: function (pageNumber) {
                var self = this;
                self.serverParamsResale.page = pageNumber;
                self.jumpToPageResale = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoadTask != 1 && self.jumpToPageResale != 1) {
                  console.log("onPerticularPageClickResale");
                  self.loadResaleComponent();

                } else if(self.firstLoadTask == 1 && self.jumpToPageResale >=1) {
                    self.loadResaleComponent();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberListResale: function () {
                var self = this;
                var totalRecord = self.totalRecordsResale;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParamsResale.perPage;
                    count++;
                }
                return count;
            },
            changedValueResaleCustomPerPageResale: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoadTask != 1) {
                  console.log("changedValueResaleCustomPerPageResale");
                self.jumpToInputPageResale(self.serverParamsResale.page);
                self.loadResaleComponent();
                }
                /* Single Backend Call on page load end */
            },
            /* Custome pagination Methods End */
            getpermissionsResale: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagTask = false;
                        if (data.status == 'success') {
                            self.cantAccessPageResale = false;
                            self.permissionsResale = data.content;

                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissionsResale.length > 0) {
                                for (var i = 0; i < self.permissionsResale.length; i++) {

                                    if (self.permissionsResale[i].name == 'can_see_resale_reason_list') {
                                        self.cantAccessPageResale = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPageResale = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            updateParamsResale(newProps) {
                this.serverParamsResale = Object.assign({}, this.serverParamsResale, newProps);
            },
            onPageChangeResale(params) {
                this.updateParamsResale({page: params.currentPage});
                console.log("onPageChangeResale");
                this.loadResaleComponent();
            },
            onPerPageChangeResale(params) {
                this.updateParamsResale({perPage: params.currentPerPage});
                this.totalRecordsResale = this.totalRecordsResale;
                console.log("onPerPageChangeResale");
                this.loadResaleComponent();
            },

            onColumnFilterResale(params) {
                this.updateParamsResale(params);
                {
                    field: ('subject');
                    field: ('due_date');
                    field: ('status');
                    field:('priority');
                    field:('description');
                    field:('cusid');
                    field:('customer_first_name');
                    field:('user_first_name');
                }
                ;
                this.serverParamsResale.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsResale));
                var filters = filtersPr.columnFilters;

                if (this.firstLoadTask == 1 || filters.subject || filters.due_date || filters.status || filters.priority
                        || filters.description || filters.cusid || filters.customer_first_name || filters.user_first_name || filters.customer_id || filters.created_at || filters.action) {
                    this.filteredFlag = true;
                    console.log("onColumnFilterResale");
                    this.loadResaleComponent();
                }

            },
            selectionChangedResale() {

                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            editResaleReason() {

                var self = this;
                // self.$router.push("/addtask");
                // if(self.resalePageData.cus_id > 0) {
                //   self.$router.push("/resale/reason/create/" + self.resalePageData.cus_id + "?sv=" + btoa(self.resalePageData.sv_tax_id) + "&pt=" + btoa(self.resalePageData.pt_tax_id));
                // } else {
                  self.$router.push("/resale/reason/create/0/"+self.lastId);
                // }

            },
            onSortChangeResale(params) {
                this.updateParamsResale({
                    sort: {
                        type: params.sortType,
                        field: this.columnsResale[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                console.log("onSortChangeResale");
                this.loadResaleComponent();
            },
            handleFilesUpload: function () {
                /*
                 Get the uploaded filesTask from the input.
                 */
                var self = this;
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesTask.files;
                //console.log(uploadedFiles);
                /*
                 Assign the uploaded file to the filesTask array
                 */
                /*this.filesTask.pop();*/
                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesTask = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
            hideModel() {
                $('#TaskdefaultModal').modal('hide');
                return false;
            },
            allClick: function () {
                var self = this;
                self.messageTask = 'all';
                console.log("allClick");
                self.loadResaleComponent();
            },
            myClick: function () {
                var self = this;
                self.messageTask = 'my';
                self.serverParamsResale.page = 1;
                self.jumpToPageResale = 1;
                console.log("myClick");
                self.loadResaleComponent();
            },
            loadResaleComponent: function () {
                var self = this;
                self.serverParamsResale.setCurrentPage = self.serverParamsResale.page;
                if (self.messageTask == 'my') {
                    self.toggleButtons(self.messageTask, 'btn_my_task', 'btn_all_task');
                } else {
                    self.toggleButtons(self.messageTask, 'btn_all_task', 'btn_my_task');
                }
                if (self.resalePageData.cus_id > 0) {
                    var fields = {
                        page: self.serverParamsResale.page,
                        perPage: self.serverParamsResale.perPage,
                        filters: self.serverParamsResale.columnFilters,
                        messageData: self.messageTask,
                        sort: self.serverParamsResale.sort,
                        exportFiltered: self.exportFilteredFlagTask,
                        custid: self.resalePageData.cus_id
                    };
                    self.storeFilters('menutaskscustomer', self.serverParamsResale, false);
                } else {
                    var fields = {
                        page: self.serverParamsResale.page,
                        perPage: self.serverParamsResale.perPage,
                        filters: self.serverParamsResale.columnFilters,
                        messageData: self.messageTask,
                        sort: self.serverParamsResale.sort,
                        exportFiltered: self.exportFilteredFlagTask
                    };
                    self.storeFilters('menuresale', self.serverParamsResale, false);
                }
                self.firstLoadTask = 1;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/resale/reason/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagTask = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsResale = data.content.row;

                            self.lastId = self.rowsResale[self.rowsResale.length - 1].ItmId;
                            console.log("lastId === ",self.lastId);
                            self.totalRecordsResale = data.content.totalRecords;
                            self.showHidePagination("resaleReasonTable", self.totalRecordsResale);
                            self.filteredFlag = false;
                            self.jumpToPageResale = self.serverParamsResale.page;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportTask').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportTask').prop("disabled", false);
                            self.downloadFile(data.content.web);
                            // location.href = data.content.web;
                        }
                        self.paginationDisplayrowsResale = self.getRecords(self.serverParamsResale.page, self.serverParamsResale.perPage, self.totalRecordsResale);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });

            },
            onDeleteClick() {
                //console.log("selected rows", self.$refs['listTaskTable'].selectedRows)
                var self = this;
                var data = self.$refs['listResaleReasonTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(self.$refs['listResaleReasonTable'].selectedRows[i].ItmId)
                }
                // console.log(use)
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                                )
                        $("#deleteTaskBtn").val("Deleting ...");
                        $.ajax({
                            url: process.env.ROOT_API + "/resale/reason/delete",
                            type: "POST",
                            data: 'ids=' + use,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                setTimeout(function () {
                                    $(".alert-success").removeClass("show");
                                    $(".alert-success").addClass("hide");
                                }, 5000);
                                setTimeout(function () {
                                    $("#deleteTaskBtn").val("Delete");
                                }, 10000);
                                self.rowsResale = data.content.row;
                                if (data.code == '200') {
                                    // alert("Hii");
                                    // self.rowsResale = data.content.row;
                                    // self.totalRecordsResale = data.content.totalRecords;
                                    // console.log("onDeleteClick");
                                    self.loadResaleComponent();
                                }
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }

                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                });

            },
  /*
            exportTask(e) {
                var self = this;
                self.exportFilteredFlagTask = true;
                if (self.exportFilteredFlagTask == true) {
                    self.loadResaleComponent();
                } else {
                    $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>...');
                    $(e.target).prop("disabled", true);
                    $.ajax({
                        url: process.env.ROOT_API + "/task/export",
                        type: "GET",
                        data: {type: 'xlsx'},
                        dataType: 'json',
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        success: function (data) {
                            if (data.status == "success") {
                                location.href = data.content.web;
                                $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                                $(e.target).prop("disabled", false);
                            } else {
                                $("#errorMsg").html(data.message);
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                }
                            }

                        },
                        error: function (jqXHR, exception) {
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server can not be reachable";
                            } else {
                                if (jqXHR.status == 401) {
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('api_token');
                                    self.$router.push("/login");
                                }

                                self.errorMsg = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            },
            importTasks(e) {
                var self = this;
                $(e.target).html('');
                $(e.target).html('Importing...');
                $(e.target).prop("disabled", true);
                var formData = new FormData();
                for (var i = 0; i < self.filesTask.length; i++) {
                    let file = self.filesTask[0];
                    formData.append('excl_file', file);
                }
                $.ajax({
                    url: process.env.ROOT_API + "/task/import",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {

                        if (data.status == "success") {
                            $("#errorMsg").html('');
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            self.loadResaleComponent();
                            self.hideModel();
                            var messageType = 'success';
                            var messageTitle = 'Success';
                            if (data.import > 0) {
                                messageType = 'success';
                                messageTitle = 'Success';
                            } else {
                                messageType = 'info';
                                messageTitle = 'Warning';
                            }
                            Swal.fire({
                                type: messageType,
                                title: messageTitle,
                                html: data.message + '<br>' + data.messageSkipRecords,
                                showConfirmButton: true,
                            });
                        } else {
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            $("#errorMsg").html(data.message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        $(e.target).html('');
                        $(e.target).html('Import');
                        $(e.target).prop("disabled", false);
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            if (jqXHR.status == 401) {
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                self.$router.push("/login");
                            }

                            self.errorMsg = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
  */
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/resalereason/ListResaleReasonComponent.vue